import { createSlice } from '@reduxjs/toolkit';
import {
    login,
    otpLoginByMail,
    submitOtpToResetPassword,
    changePassword,
    updateUserProfile,
    updateProfilePicture,
    getMyProfile
    // addReview
} from '../../../API/Auth';

const initialState = {
    loading: false,
    userInfo: null,
    userToken: null,
    error: null,
    success: false,
    userProfile: {},
    role: "admin"
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        //logout reducer
        logout: (state) => {
            state.loading = false;
            state.userInfo = null
            state.userToken = null;
            state.error = null;
            state.success = false;
        },
        toggleForgotPassword: (state) => {
            state.forgotPassword = !state.forgotPassword;
        },
        setUserProfile: (state, { payload }) => {
            state.userProfile = payload;
        },
        setUserInfo: (state, { payload }) => {
            state.userInfo = payload;
        },
        setUserToken: (state, { payload }) => {
            state.loading = false;
            state.userInfo = payload.data;
            state.userToken = payload.token;
            state.success = true;
        },
        setUserSuccess: (state, { payload }) => {
            state.success = true;
        }
    },
    extraReducers: {
        //login reducer
        [login.pending]: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        },
        [login.fulfilled]: (state, { payload }) => {
            console.log('payload', payload);
            state.loading = false;
            state.userInfo = payload.data;
            state.userToken = payload.token;
            state.error = null;
            // state.success = true;
        },
        [login.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            state.success = false;
        },

        // New reducer for handling forgotPassword action
        [otpLoginByMail.pending]: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        },
        [otpLoginByMail.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
        },
        [otpLoginByMail.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            state.success = false;
        },

        // New reducer for handling OTP submission action
        [submitOtpToResetPassword.pending]: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        },
        [submitOtpToResetPassword.fulfilled]: (state) => {
            state.loading = false;
            state.error = null;
            // state.success = true;
        },
        [submitOtpToResetPassword.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            state.success = false;
        },

        // reducer for handling change password
        [changePassword.pending]: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        },
        [changePassword.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.error = null;
            state.success = false;
        },
        [changePassword.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            state.success = false;
        },
        [updateUserProfile.pending]: (state) => {
            state.loading = true;
            state.error = null;
        },
        [updateUserProfile.fulfilled]: (state, { payload }) => {
            state.loading = false;
            if (payload && payload.data) {
                state.userInfo = payload.data;
                state.userProfile = payload.data;
            }
            state.error = null;
        },
        [updateUserProfile.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
        },
        [updateProfilePicture.pending]: (state) => {
            state.loading = true;
            state.error = null;
        },
        [updateProfilePicture.fulfilled]: (state, { payload }) => {
            state.loading = false;
            if (payload && payload.result) {
                state.userInfo = payload.result;
                state.userProfile = payload.result;
            }
            state.error = null;
        },
        [updateProfilePicture.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
        },
        [getMyProfile.pending]: (state) => {
            state.loading = true;
            state.error = null;
        },
        [getMyProfile.fulfilled]: (state, { payload }) => {
            state.loading = false;
            if (payload && payload.data && payload.data.user) {
                state.userInfo = payload.data.user;
                state.userProfile = payload.data.user;
            }
            state.error = null;
        },
        [getMyProfile.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
        }
    }
});

export const {
    logout,
    setUserProfile,
    setUserInfo,
    setUserToken,
    setUserSuccess
} = authSlice.actions;
export default authSlice.reducer;
